import { render, staticRenderFns } from "./CAxAALxClarificationsPage.vue?vue&type=template&id=40f0b078"
import script from "./CAxAALxClarificationsPage.vue?vue&type=script&lang=js"
export * from "./CAxAALxClarificationsPage.vue?vue&type=script&lang=js"
import style0 from "./CAxAALxClarificationsPage.vue?vue&type=style&index=0&id=40f0b078&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports